import { getServerUrl } from '../../config/server.config';

class TransactionService {

    private get baseUrl(): string {
        return getServerUrl(true);
    }
   
    // Get last 10 (default)
    async getRecentTransactions() {
        return await this.fetchTransactions();
    }
    // Get last 100
    async getMoreTransactions() {
        return await this.fetchTransactions({ limit: 100 });
    }
    // Get by quarter
    async getQuarterTransactions(quarter, year = 2025) {
        const quarters = {
            1: { from: `${year}-01-01`, to: `${year}-03-31` },
            2: { from: `${year}-04-01`, to: `${year}-06-30` },
            3: { from: `${year}-07-01`, to: this.getCurrentDate() },
            4: { from: `${year}-10-01`, to: this.getCurrentDate() }
        };
        const { from, to } = quarters[quarter];
        return await this.fetchTransactions({
            limit: 100,
            fromDate: from,
            toDate: to
        });
    }
    // Base method for all calls
    async fetchTransactions(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const url = `${this.baseUrl}/verestro/transactions${queryString ?
            '?' + queryString : ''}`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    getCurrentDate() {
        return new Date().toISOString().split('T')[0];
    }
    getToken() {
        return localStorage.getItem('token');
    }
}

export const transactionService = new TransactionService();